import { render, staticRenderFns } from "./LecturesList.vue?vue&type=template&id=52183ed5&scoped=true"
import script from "./LecturesList.vue?vue&type=script&lang=js"
export * from "./LecturesList.vue?vue&type=script&lang=js"
import style0 from "./LecturesList.vue?vue&type=style&index=0&id=52183ed5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52183ed5",
  null
  
)

export default component.exports